"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.search.failed': 'Nie udało się przeszukać logów. Spróbuj ponownie.',
};
